import { Box, Menu, MenuItem, Tooltip } from "@mui/material";
import React, { useState } from "react";
import { useHistory } from "react-router-dom";

interface IItemProps {
  icon: any;
  title: string;
  isActive: boolean;
  submenus: any[];
  route?: string;
  onClick(target: string): void;
}

export function CollapsedItem(props: IItemProps) {
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [openMenu, setOpenMenu] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const handleClick = (e: any) => {
    if (props.submenus.length < 1 && props.route) history.push(props.route);

    if (props.submenus.length > 1) {
      setAnchorEl(e.currentTarget);
      setOpenMenu(true);
      setTooltipOpen(false);
    }
  };

  const activeStyle = {
    color: "#FFF",
    backgroundColor: "#1361A4",
    borderRadius: "4px",
    cursor: "pointer",
  };

  return (
    <Tooltip
      open={tooltipOpen}
      onOpen={() => setTooltipOpen(true)}
      onClose={() => setTooltipOpen(false)}
      disableFocusListener
      disableHoverListener
      disableTouchListener
      placement="right-end"
      title={<span style={{ fontSize: "16px" }}>{props?.title}</span>}
    >
      <Box
        onMouseEnter={() => setTooltipOpen(true)}
        onMouseLeave={() => setTooltipOpen(false)}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          py={1}
          px={1}
          my={1}
          sx={
            props.isActive
              ? activeStyle
              : {
                  cursor: "pointer",
                  backgroundColor: "rgba(75, 70, 92, 0.04)",
                  borderRadius: "4px",
                }
          }
          onClick={handleClick}
        >
          <Box
            display={"flex"}
            alignItems={"center"}
            justifyContent={"center"}
            width={24}
            height={24}
          >
            {props.icon}
          </Box>
        </Box>

        <Menu
          id="basic-menu"
          anchorEl={anchorEl}
          open={openMenu}
          onClose={() => {
            setAnchorEl(null);
            setOpenMenu(false);
          }}
          autoFocus={false}
        >
          {props.submenus.map((menu) => {
            return (
              <MenuItem
                key={menu?.title}
                autoFocus={false}
                onClick={() => {
                  setAnchorEl(null);
                  setOpenMenu(false);
                  setTooltipOpen(false);
                  if (menu?.route) {
                    history.push(menu.route);
                  }
                }}
              >
                {menu?.title}
              </MenuItem>
            );
          })}
        </Menu>
      </Box>
    </Tooltip>
  );
}
